import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import './Home.css'; // Ensure the CSS file is correctly linked
import { Link } from 'react-router-dom';
import Leaderboard from './Leaderboard'; // Import the new Leaderboard component

function Home() {
    const [showSearchBar, setShowSearchBar] = useState(false);
    const [searchType, setSearchType] = useState('Players');
    const [searchInput, setSearchInput] = useState('');

    const handleSearchClick = () => {
        setShowSearchBar(!showSearchBar);
    };

    const handleSearchTypeClick = (type) => {
        setSearchType(type);
    };

    const handleSearchInputChange = (event) => {
        setSearchInput(event.target.value);
    };

    const handleSearch = () => {
        if (searchType === 'Players') {
            // Handle player search
            console.log(`Searching for player: ${searchInput}`);
        } else if (searchType === 'Teams') {
            // Handle team search
            console.log(`Searching for team: ${searchInput}`);
        } else if (searchType === 'Clubs') {
            // Handle club search
            console.log(`Searching for club: ${searchInput}`);
        }
    };

    return (
        <div className="home">
           <Helmet>
                <title>RCScouting - Discover and Connect with Top Rocket League Players and Teams</title>
                <meta name="description" content="Join RCScouting to find and connect with the best Rocket League players and teams. Enhance your gameplay and networking within the community today!" />
            </Helmet> 
            <header className="features-header">
                <ul className="features-list">
                    <li onClick={handleSearchClick}> Search </li>
                    <li><Link to="/forums" className="feature-link">Join Community Forums</Link></li>
                    <li><Link to="/teams" className="feature-link">Connect with Teams</Link></li>
                </ul>
            </header>
            {showSearchBar && (
                <div className="search-bar-container">
                    <ul className="search-options">
                        <li className={searchType === 'Players' ? 'active' : ''} onClick={() => handleSearchTypeClick('Players')}>Players</li>
                        <li className={searchType === 'Teams' ? 'active' : ''} onClick={() => handleSearchTypeClick('Teams')}>Teams</li>
                        <li className={searchType === 'Clubs' ? 'active' : ''} onClick={() => handleSearchTypeClick('Clubs')}>Clubs</li>
                    </ul>
                    <div className="search-bar">
                        <input
                            type="text"
                            placeholder={`Search ${searchType.toLowerCase()}...`}
                            value={searchInput}
                            onChange={handleSearchInputChange}
                        />
                        <button onClick={handleSearch}>Search</button>
                    </div>
                </div>
            )}
            <div className="hero">
                <div className="hero-content">
                    <h1>Welcome to RCScouting</h1>
                    <p>Discover and connect with top players and teams.</p>
                </div>
                <div className="cta">
                    <h2>Join Our Community</h2>
                    <Link to="/signup">
                        <button>Sign Up Now</button>
                    </Link>
                </div>
            </div>
            <section className="about">
                <h2>About Us</h2>
                <p>This site helps Rocket League players get noticed and teams to find their next champion. We provide a platform where players can showcase their skills, connect with like-minded individuals, and join competitive teams. Whether you're a player looking to get scouted or a team looking for new talent, RCScouting is the place for you.</p>
            </section>
            <section className="threat-list-section">
                <h2>Threat List</h2>
                <div className="threat-list">
                    <div className="threat-list-container">
                        <div className="threat-box">Player 1</div>
                        <div className="threat-box">Player 2</div>
                        <div className="threat-box">Player 3</div>
                        <div className="threat-box">Player 4</div>
                        <div className="threat-box">Player 5</div>
                        <div className="threat-box">Player 6</div>
                        <div className="threat-box">Player 7</div>
                        <div className="threat-box">Player 8</div>
                        <div className="threat-box">Player 9</div>
                        <div className="threat-box">Player 10</div>
                        
                    
                     </div>
                    
                </div>
            </section>
            <Leaderboard /> {/* Add the Leaderboard component here */}
            
            <section className="testimonials">
                <h2>Success Stories</h2>
                <p>"Thanks to this site, I found a competitive team to join!" - Happy Gamer</p>
            </section>
            <footer className="footer">
                <a href="src\components\PrivacyPolicy.js">Privacy Policy</a> |
                <a href="/terms-of-service">Terms of Service</a>
                <p>This site is not affiliated with or endorsed by Psyonix LLC or Epic Games. Rocket League is a registered trademark of Psyonix LLC.</p>
            </footer>
        </div>
    );
}

export default Home;
